import { LocalStorageKey } from '@core';
import { defaultDistanceMeters, noDistanceLimit } from '../../application/utils';

/**
 * Wybór użytkownika w filtrze odległości - przeżywa restart aplikacji.
 * Brak wpisu = użytkownik nic nie wybrał, więc obowiązuje `defaultDistanceMeters`.
 * `noDistanceLimit` (0) to świadomy wybór "Bez limitu" - odróżniony od braku wpisu.
 */
export class DistanceFilterStorage {
  get selected(): number {
    const raw: string | null = localStorage.getItem(LocalStorageKey.SelectedDistance);
    if (raw === null) return defaultDistanceMeters;

    const parsed: number = Number(raw);
    return Number.isFinite(parsed) && parsed >= noDistanceLimit ? parsed : defaultDistanceMeters;
  }

  /** Wartość dla `FiltersValues` - "Bez limitu" jest tam reprezentowane brakiem wartości. */
  get selectedAsFilterValue(): number | undefined {
    const selected: number = this.selected;
    return selected === noDistanceLimit ? undefined : selected;
  }

  save(distance: number | undefined): void {
    localStorage.setItem(LocalStorageKey.SelectedDistance, String(distance ?? noDistanceLimit));
  }

  clear(): void {
    localStorage.removeItem(LocalStorageKey.SelectedDistance);
  }
}
